<style scoped>

  @media only screen and (max-width: 990px) {
    .main-segment {
      min-height: 400px !important;
    }
    .next-button-segment {
      height: 80px !important;
    }
    .no-data-grid {
      height: 300px !important;
    }
  }

  @media only screen and (min-width: 991px) {
    .main-segment {
      min-height: 830px !important;
    }
    .labels-segment {
      margin-top: -20px !important;
    }    
    .no-data-grid {
      height: 700px !important;
    }
  } 

</style>

<template>  

  <div class="ui segment main-segment" :class="{ loading }">

    <h4 class="ui dividing header">
      Mural de Recados
      <span v-if="notesCount.total > 0" class="ui small label">
        <i class="star icon"></i> {{ notesCount.total == 1 ? "1 novo recado" : notesCount.total + " novos recados" }}
      </span>      
    </h4>     

    <div class="ui grid">

      <div class="sixteen wide column">
        <router-link to="/notes-historic" class="ui mini basic button">
          <i class="history violet icon"></i> Histórico
        </router-link>
        <router-link v-if="$isSimavet()" to="/admin/notes/new" class="ui mini basic button m-l-10">
          <i class="plus blue icon"></i> Novo recado
        </router-link>
      </div>

      <div v-if="notesCount.total > 1" class="sixteen wide column" style="margin-bottom: -10px !important;">
        <div class="ui basic center aligned segment no-padding no-margin labels-segment">
          <div class="ui labels">
            <div v-if="notesCount.urgent > 0" class="ui red label">
              <i class="exclamation circle icon"></i> {{ notesCount.urgent == 1 ? "1 urgente" : notesCount.urgent + " urgentes" }}
            </div>
            <div v-if="notesCount.warning > 0" class="ui orange label">
              <i class="exclamation triangle icon"></i> {{ notesCount.warning == 1 ? "1 alerta" : notesCount.warning + " alertas" }}
            </div>
            <div v-if="notesCount.info > 0" class="ui blue label">
              <i class="info circle icon"></i> {{ notesCount.info == 1 ? "1 informativo" : notesCount.info + " informativos" }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentNote" class="sixteen wide column">

        <note-segment :note="currentNote" />

        <div class="ui basic centered segment next-button-segment">
          <div v-if="!loading" class="ui animated large blue button" tabindex="0" @click="onShowNextNote()">
            <div class="visible content">
              {{ notesCount.total > 1 ? 'Próximo' : 'OK' }}
            </div>
            <div class="hidden content">
              <i v-if="notesCount.total > 1" class="right arrow icon"></i>
              <i v-else class="check icon"></i>
            </div>
          </div>
        </div>

      </div>

      <div v-if="!loading && !currentNote" class="sixteen wide column animated fadeIn">
        <div class="ui middle aligned grid no-data-grid">
          <div class="sixteen wide column">
            <div class="ui basic centered segment">
              <div class="ui icon header grey text">
                <i class="info circle icon"></i>
                Nenhum novo recado
              </div>              
            </div>
          </div>
        </div>
      </div>

    </div>                        

  </div>

</template>

<script>

  import NoteService from "@/services/note-service"
  import replaceAll from "@/utils/replace-all"
  import NoteSegment from "@/components/note-segment"

  export default {
    
    name: "Notes",

    data() {
      return {
        notes: [],
        currentNote: null,
        loading: true,
        service: new NoteService(),
      }
    },

    components: {
      NoteSegment,
    },

    computed: {

      notesCount() {

        let data = {
          total: 0,
          urgent: 0,
          warning: 0,
          info: 0,
        }

        this.notes.forEach((note) => {
          data[note.severity]++
        })

        data.total = (data.urgent + data.warning + data.info)

        return data
      },
    },

    mounted() {
      this.loadNotes()
    },

    methods: {

      async loadNotes() {

        this.loading = true

        try {

          let notes = []
          let userNotes = await this.service.findUserNotes(this.$store.state.auth.user.id)
          
          this.addNotes("urgent", userNotes, notes)
          this.addNotes("warning", userNotes, notes)
          this.addNotes("info", userNotes, notes)

          if (notes.length > 0) {
            await this.setCurrentNote(notes[0])
          } else {
            this.currentNote = null
          }  

          this.notes = notes.slice()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      addNotes(severity, userNotes, notes) {

        for (let note of userNotes) {
          if (note.severity == severity)
            notes.push(note)
        }
      },

      async setCurrentNote(note) {

        try {

          this.currentNote = this.$cloneObject(note)

          if (this.currentNote.message)
            this.currentNote.message = replaceAll(this.currentNote.message, "\n", "<br/>")  

          if (this.currentNote.hasImage)
            this.currentNote.image = await this.service.getNoteImage(note.noteId)

          this.currentNote = this.$cloneObject(this.currentNote)  
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      async onShowNextNote() {

        this.loading = true

        try {

          await this.service.setNoteViewed(this.currentNote.noteId, this.$store.state.auth.user.id)
          
          await this.loadNotes()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>